// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gHny","colMin":"styles_colMin__3MKPz"};